import { loadStripe } from '@stripe/stripe-js';

// Load Stripe.js on the client side
export const getStripe = () => {
  // Replace with your actual Stripe publishable key from your Stripe account dashboard
  const stripePublicKey = process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY;
  
  if (!stripePublicKey) {
    throw new Error('Stripe publishable key is not defined in environment variables');
  }
  
  return loadStripe(stripePublicKey);
};

// Price ID for the Pro subscription tier
export const STRIPE_PRICE_ID = process.env.NEXT_PUBLIC_STRIPE_PRO_PRICE_ID || 'price_placeholder_pro';

// Helper to get the price ID for the Pro tier
export const getPriceIdForTier = () => {
  return STRIPE_PRICE_ID;
}; 